/**
 * Feedback API Functions (WS8-E)
 */

import { api } from './client';

export type FeedbackCategory = 'BUG' | 'IDEA' | 'QUESTION' | 'OTHER';

export interface FeedbackRequest {
  category: FeedbackCategory;
  message: string;
  pageUrl?: string;
  userAgent?: string;
  orgSlug?: string;
  orgRole?: string;
}

export interface PublicFeedbackRequest {
  category: FeedbackCategory;
  message: string;
  email: string;
  turnstileToken?: string;
  pageUrl?: string;
  userAgent?: string;
}

export interface FeedbackResponse {
  message: string;
  feedbackId: string;
}

/** Authenticated in-app feedback. */
export async function submitFeedback(data: FeedbackRequest): Promise<FeedbackResponse> {
  const response = await api.post<FeedbackResponse>('/feedback', data);
  return response.data;
}

/** Logged-out landing-page feedback/contact form. */
export async function submitPublicFeedback(
  data: PublicFeedbackRequest
): Promise<FeedbackResponse> {
  const response = await api.post<FeedbackResponse>('/feedback/public', data);
  return response.data;
}
